/* eslint-disable no-console */
import axios, {AxiosError} from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useJSONStore from '../../../store/StaticJson/jsonStore';
import useUserStore from '../../../store/userStore/userStore';

interface ErrorResponse {
  message: string;
}

const editUserApi = async (data: any = undefined): Promise<any> => {
  const token = useUserStore.getState().userToken;
  const roleTypes = useJSONStore.getState().roleTypes;
  const accessTypes = useJSONStore.getState().accessTypes;
  const role = roleTypes.find((item) => item.name === data.roles);
  const access = accessTypes.find(
    (item) => item.description === data.selectedAccess
  );
  const body = {
    user: data.user,
    roles: [role.id, access.id],
    roleNames: [role.name, access.name],
    permissions: data.permissions
  };
  try {
    const res = await axios.request({
      method: CRUDMethods.PUT,
      url: `${API_BASE_URL}${API_ENDPOINT_JSON.editUser}`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      data: body
    });

    return res.data;
  } catch (err) {
    const axiosError = err as AxiosError;
    if (axiosError.response) {
      const responseData = axiosError.response.data as ErrorResponse;

      return {
        status: 'error',
        message: responseData.message || 'An error occurred'
      };
    }

    return {
      status: 'error',
      message: axiosError.message || 'An error occurred'
    };
  }
};

export default editUserApi;
